<template>
  <div class="vx-row pb-3" v-show="isCardActiveLocal">
    <div class="vx-col w-full"> 
        <div class="w-full">
          <vx-card id="documentsCard" ref="Document" title="Documents" v-show="!isDocumentListHidden">        
            <div id="data-list-thumb-view" class="data-list-container listdocumentstable">
              <vs-table :sst="false" pagination :max-items="pageSize" search :data="documents" stripe ref="documentTable" class="vs-con-loading__container" single @selected="handleSelectedDocument"> <!-- @sort="handleSort" -->
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
                  <!-- ADD NEW -->
                  <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDocument">
                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                    <span class="ml-2 text-base text-primary">Add New</span>
                  </div>
                </div>
                <template slot="thead">
                  <vs-th></vs-th>
                  <vs-th>Name</vs-th>
                  <vs-th>Description</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="document" :state="document.isActive == false ? 'warning':null" :key="indextr" v-for="(document, indextr) in data" >
                    <vs-td style="text-align: -webkit-center;width:80px;text-align: -moz-center;">
                      <img src="../../../assets/images/multi-media-book-icon.png" height="50px" />
                    </vs-td>             
                    <vs-td>
                      {{ document.name}}
                    </vs-td>
                    <vs-td>
                      {{ document.description }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
        <div style="text-align:left">
          <vx-card id="documentInfoCard" ref="documentInfo" title="Document Info" v-show="!isInfoHidden">
            <vs-divider class="mb-6 pt-0">Document Details</vs-divider>        
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Name</label>
                <vs-input autocomplete="off" onClick="this.select();" v-validate="'required'" name="Name" class="w-full" v-model="formData.name" />
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Description</label>
                <vs-textarea v-model="formData.description" />            
              </div>
            </div>
            <div class="vx-row pb-3">
              <div class="vx-col xs:w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-2">
                <label>Module</label>
                <v-select
                  ref="moduleDropdown"
                  placeholder="Select a Module"
                  :options="modulesList"
                  class="w-full"
                  v-model="moduleDropdown"
                ></v-select>
              </div>
            </div>

            <vs-divider class="mb-6 pt-0">Tags</vs-divider>
              <div class="vx-row">
                <vs-chips id="tags" class="vx-col w-full pt-2" color="rgb(145, 32, 159)" placeholder="Add Tags" v-model="formData.tags">
                  <vs-chip
                    class="glow-effect_primary"
                    :key="chip"
                    @click="removeTag(chip)"
                    v-for="chip in formData.tags"
                    closable>
                    {{ chip }}
                  </vs-chip>
                </vs-chips>
              </div>

            <vs-divider class="mb-6 pt-0">Document Upload</vs-divider>
              <div class="vx-col w-1/3 mx-auto self-center">
                <file-pond
                    v-show="true"
                    id="document-filepond"
                    ref="documentUploadPond"
                    allowPaste=false
                    :server="uploadLocation"
                    label-idle="Drop PDF file here or <span class='filepond--label-action' text-decoration-color: #aaa>Browse</span>"
                    accepted-file-types="application/pdf"
                    :allow-multiple="false"
                    :instant-upload="true"
                    @processfile="uploadCompletePdf"
                    @removefile="fileRemovedPdf"
                  />
              </div>

            <div class="vx-row">
              <div class="vx-col sm:w-2/3 w-full mb-2 mx-auto">
                <div v-show="formData.id">
                  <vs-table ref="documentUploadTable" single max-items="5" :data="uploadedDocumentFile">
                    <template slot-scope="{data}">
                      <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data"> 
                        <vs-td>
                          <p class="product-name font-medium">{{ file.url }}</p>
                        </vs-td>                   
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>                      
              </div>
            </div>
            
            <vs-divider class="mb-6 pt-0"></vs-divider>
            
            <div class="vx-row">
              <vs-spacer></vs-spacer>
              <div class="vx-col flex">
                <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color mr-3">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                        <span><feather-icon class="pt-2" icon="CheckIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="!(formData.url && formData.name && moduleDropdown)"
                      size="large"
                      class="w-full button-text__left-align glow-effect_success vs-con-loading__container"
                      color="success"
                      style="border-radius:0 7px 7px 0;"
                      ref="saveEditButton"
                      @click="saveEditDocument">
                      Save
                    </vs-button>
                  </vx-input-group>
                </vx-card>
                <vx-card v-show="formData.id" class="mb-4 glow-effect_dark card__no-padding bg-color mr-3">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                        <span><feather-icon class="pt-2" icon="Trash2Icon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      
                      size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_danger vs-con-loading__container"
                      color="danger"
                      style="border-radius:0 7px 7px 0;"
                      ref="deleteButton"
                      @click="deleteDocument">
                      Delete
                    </vs-button>
                  </vx-input-group>
                </vx-card>          
                <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                        <span><feather-icon class="pt-2" icon="XIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_warning "
                      color="warning"
                      style="border-radius:0 7px 7px 0;"
                      @click="cancelAdd">
                      Cancel
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </div>
            </div>
          </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

  export default {
    components: {
      'v-select': vSelect,
      FilePond
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      modulesList: {
        required: false
      }
    },
    data() {
      return {
        isDocumentListHidden: false,
        pageSize: 10,
        documents: [],
        isInfoHidden: true,
        formData: {
          id: 0,
          siteId: 0,
          name: "",
          description: "",
          url: "",
          tags: [],
          moduleId: null
        },
        uploadedDocumentFile: [],
        moduleDropdown: 0
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {           
          }
        }        
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
      
    },
    watch: {      
      isCardActive: function(val) {
        if(val){
          var self = this;
          self.loadDocumentData();
        }
      }
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.name = "";
        this.formData.description = "";
        this.formData.url = "";
        this.formData.tags = [];
        this.formData.moduleId = null;
        this.moduleDropdown = 0;
        this.mode = "";
        this.errors.clear();
        this.uploadedDocumentFile = [];
        this.$refs.documentUploadPond.removeFiles();
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
        this.isDocumentListHidden = false;
        this.$emit("showBackButton");
      },      
      addNewDocument() {
        this.initValues();
        this.isDocumentListHidden = true;
        this.isInfoHidden = false;
        this.mode = "Add Document";
        this.$emit("hideBackButton");
      },
      handleSelectedDocument(document) {
        this.$emit("hideBackButton");
        this.mode = "Edit Document";
        this.isDocumentListHidden = true;
        this.isInfoHidden = false;
        this.formData.id = document.id;
        this.formData.name =  document.name;    
        this.formData.description = document.description;
        this.formData.url = document.url;
        this.formData.tags = document.tags;
        this.formData.moduleId = document.moduleId;
        
        if (document.moduleId) {
          this.moduleDropdown = this.modulesList.filter(function(item){return item.value == document.moduleId})[0];
        }

        this.uploadedDocumentFile.push({
          url: document.name,       
        })

        this.$refs.documentUploadPond.removeFiles();
      },
      saveEditDocument() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnElement("saveEditButton", 0.45, "material");

            self.formData.moduleId = self.moduleDropdown ? parseInt(self.moduleDropdown.value) : null;

            var onSuccess = response => {
              self.uploadedDocumentFile = [];
              self.isInfoHidden = true;
              self.isDocumentListHidden = false;
              self.$emit("showBackButton");
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Document Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
              self.loadDocumentData()
            };
        
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };

            self.$ajaxPost(self, "Document/AddEditMultiMediaDocument", self.formData, onSuccess, onFinally);
          }
          else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteDocument(){
        var self = this;
        self.showLoadingOnElement("deleteButton", 0.45, "material");
        var onSuccess = response => {
          self.uploadedDocumentFile = [];
          self.isInfoHidden = true;
          self.isDocumentListHidden = false;
          self.$emit("showBackButton");
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Document Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash-2'
          });
          self.loadDocumentData()
        };

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };

        self.$ajaxGet(self, "Document/DeleteMultiMediaDocument/" + self.formData.id, onSuccess, onFinally); 
      },      
      loadDocumentData() {
        var self = this;
        self.showLoadingOnElement("documentTable", 1, "material");

        var onSuccess = function (response) {
          self.documents = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.documentTable.$el);
        };

        self.$ajaxGet(self,"Document/ListMentorMultiMediaDocuments", onSuccess, onFinally);
      },
      uploadCompletePdf(error, file) {
        var response = JSON.parse(file.serverId);
        if(response.url){
          this.uploadedDocumentFile = [];
          this.formData.url = response.url;
          this.uploadedDocumentFile.push({
            url: file.filename,        
          })
        }                  
      },
      fileRemovedPdf(error, file) {
        this.formData.url = "";
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      removeTag(tagItem) {
        this.formData.tags.splice(this.formData.tags.indexOf(tagItem), 1)
      },
      addTag(){
        this.formData.tags.push(this.tagToAdd);
        this.tagToAdd = ""; 
      }
    }
  }

</script>

<style lang="scss">
  #studentComment {
    box-shadow: 0 4px 20px 0 rgba(var(--vs-danger),0.3);
  }

  #document-filepond {
    label {
      color: black !important;
    }
  }
</style>
